<div class="checkbox-tree-filter">
    <brt-checkbox-tree-filter-group (toggleOption)="onOptionToggle($event)" [option]="option" *ngFor="let option of options; trackBy: trackItem"></brt-checkbox-tree-filter-group>
</div>
